<div *ngIf="loading" class="overlay">
  <div class="spinner"></div>
</div>

 
<blockquote>
    <h5 class="headings">VENDOR  INFORMATION</h5>
  </blockquote>
  <form #form="ngForm" (ngSubmit)="onSubmit()">
    <div class="row">
      <p class="error">{{error_message}}</p>
    </div>
    <div class="row s12">
      <div class="col s12">
        <label for="companyname">* Company Name: </label>
        <input type="text" placeholder="Company Name" id="companyname" 
          [(ngModel)]="company.strCompanyName" name="companyname"
          [disabled]="!isOriginalSubmission" 
        required />
      </div>
    </div>
    <div class="row s12">
      <div class="col s4">
        <label for="address">* Registered Address:  </label>
        <select *ngIf="company.strRegisteredCountry == ''" style="display: block;" id="size" name="size" required [(ngModel)]="company.strRegisteredCountry"> <!--revisit how this is being done-->
          <option value="" disabled selected>Select Country</option>
          <option *ngFor="let country of countries" [value]="country">{{ country }}</option>
        </select>
        <div *ngIf="company.strRegisteredCountry != ''"> 
          <h6 style="margin-left: 30px;">
            {{ company.strRegisteredCountry }}
            <button *ngIf="!isViewOnly" class="remove" style="display: inline-block;" (click)="removeCountryReg()">Remove</button>
          </h6>
        </div>
      </div>
      <div class="col s8">
        <label for="address" style="color: white;">..</label>
        <input type="text" placeholder="BLDG#, Street Address, City" id="address" [(ngModel)]="company.strRegisteredAddress" name="address"
        [readonly]="isViewOnly"  required />
      </div>
    </div>
    <div class="row s12">
      <div class="col s4">
        <div *ngIf="company.strnumEmployees != ''"> 
          <label style="display: inline-block;">Selected Company Size:</label>
          <h6 style="margin-left: 30px;">
            {{ company.strnumEmployees }}
            <button *ngIf="!isViewOnly" class="remove" style="display: inline-block;" (click)="removeSize()">Remove</button>
          </h6>
        </div>
       <div *ngIf="company.strnumEmployees == ''">
        <label for="size">* Company Size: </label>
        <select style="display: block;" id="size" name="size" required 
          [(ngModel)]="company.strnumEmployees" 
          [disabled]="isViewOnly">
          <option value="" disabled>Choose company size</option>
          <optgroup label="Small Businesses:">
            <option value="1-2">1-2</option>
            <option value="3-10">3-10</option>
            <option value="11-25">11-25</option>
            <option value="26-50">26-50</option>
          </optgroup>
          <optgroup label="Medium-Sized Businesses:">
            <option value="51-100">51-100</option>
            <option value="101-250">101-250</option>
            <option value="251-500">251-500</option>
          </optgroup>
          <optgroup label="Large Enterprises:">
            <option value="501-1000">501-1,000</option>
            <option value="1001-5000">1,001-5,000</option>
            <option value="5001-10000">5,001-10,000</option>
            <option value="10000+">10,000+</option>
          </optgroup>
        </select>
       </div>
      </div>
      <div class="col s4">
        <label for="est-date" class="active">* Date Business Established:</label>
        <input type="date" placeholder="Date Business Established" id="est-date" 
          [(ngModel)]="company.dteEstablished" name="est-date" [max]="maxDate" 
          [readonly]="isViewOnly" 
          required />
      </div>
      <div class="col s4">
        <label for="regno">* Company Registration Number: </label>
        <input type="text" placeholder="Company Registration Number" id="regno" 
          [(ngModel)]="company.strRegistrationNum" name="regno"
          [readonly]="isViewOnly" 
        required />
      </div>
    </div>
    <div class="row s12">
      <div class="col s4">
        <label for="address">Mailing Address: </label>
        <select *ngIf="company.strMailingCountry == ''" style="display: block;" id="size" name="size" required [(ngModel)]="company.strMailingCountry">
          <option value="" disabled selected>Select Country</option>
          <option *ngFor="let country of countries" [value]="country">{{ country }}</option>
        </select>
        <div *ngIf="company.strMailingCountry != ''"> 
          <h6 style="margin-left: 30px;">
            {{ company.strMailingCountry }}
            <button *ngIf="!isViewOnly" class="remove" style="display: inline-block;" (click)="removeCountryMail()">Remove</button>
          </h6>
        </div>
      </div>
      <div class="col s8">
        <label for="mailing" style="color: white;">..</label>
        <input type="text" placeholder="Mailing Address (if different from above)" id="mailing" 
        [(ngModel)]="company.strMailingAddress" name="mailing"
        [readonly]="isViewOnly" 
         />
      </div>
    </div>
    <div class="row s12">
      <div class="col s6">
          <label for="name">* Contact Person: </label>
          <input type="text" class="green-input" placeholder="John Doe" 
          [(ngModel)]="user.strName" id="name" name="name" 
          [readonly]="isViewOnly" 
          required />
      </div>
      <div class="col s6">
        <label for="position">* Job Title: </label>
        <input type="text" class="green-input" placeholder="Position" 
        [(ngModel)]="user.strJobTitle" id="position" name="position" 
        [readonly]="isViewOnly" 
        required />
      </div>
    </div>
    <div class="row s12">
      <div class="col s6">
        <label for="email">* Email: </label>
          <input type="text" placeholder="youremail@company.com" 
          [(ngModel)]="user.strEmail" id="email" name="email" 
          #emailInput required (input)="validateEmail(emailInput.value)"
          [readonly]="true" disabled
        />
      </div>
      <div class="col s6">
        <label for="contact">* Phone Number: </label>
        <input type="text" placeholder="1234567890" 
         [(ngModel)]="user.strContact" id="contact" name="contact" required
         #phoneInput (input)="validatePhoneNumber(phoneInput.value)"
         [readonly]="isViewOnly" 
         />
      </div>
    </div>
    <div class="row s12">
      <div class="col s12">
        <label for="website">Company Website: </label>
        <input type="text" placeholder="www.company.com" [(ngModel)]="company.strCompanyWebsite"
         id="website" name="website" required 
         [readonly]="isViewOnly" 
        />
      </div>
    </div>
    <div class="card">
      <div class="radio-row"> 
        <h6>Are you affiliated with anyone working for UNIPET or its subsidiaries? *</h6>
        <label>
          <input name="group1" type="radio" 
          [checked]="company.blnAffiliation === true"
          (change)="company.blnAffiliation = true"
          [disabled]="isViewOnly">
          <span class="radio">Yes</span>
        </label>
        <label>
          <input name="group1" type="radio" [value]="false"  [checked]="company.blnAffiliation === false"
          (change)="company.blnAffiliation = false; removeAffiliation()"
          checked/>
          <span class="radio">No</span>
        </label>
      </div>
      <div class="row s12" *ngIf="company.blnAffiliation === true">
        <div class="col s4">
          <h6 style="color: gray">*UNIPET/Subsidary: </h6>
          <select style="display: block; background-color: white !important;" id="size" name="size" required [(ngModel)]="company.strCompanyAffiliated">
            <option value="" disabled selected>Select</option>
            <option *ngFor="let subsidary of subsidaries" [value]="subsidary">{{ subsidary }}</option>
          </select>
        </div>
        <div class="col s8">
          <h6 style="color: gray">You selected YES, provide details: </h6>
          <input class="white-input"
            id="affil-details" name="affil-details" [(ngModel)]="company.strAffiliation"
            [readonly]="isViewOnly">
        </div>
      </div>
    </div>
  </form>
  <br>

  <app-b-category-form *ngIf="isViewOnly" [isViewOnly]="true" [formData]="formData"></app-b-category-form>
  <app-b-category-form *ngIf="!isViewOnly" [formData]="formData"></app-b-category-form>

